import { combineReducers } from 'redux';

import appointmentList from './requests/appointment-list-req';
import locations from './requests/locations-req';
import updateRoom from './requests/change-room-req';
import changeStatus from './requests/change-status-req';
import pinAppointment from './requests/pin-req';
import appointmentLocations from './requests/appointment-locations-req';
import changePaidStatus from './requests/change-paid-status-req';
import changeRoomModal from './change-room-modal';
import editPaymentAmountModal from './edit-payment-amount-modal';
import changePaidStatusModal from './change-paid-status-modal';
import filter from './filter';
import record from './record';
import validatePatientInfo from './requests/validate-patient-info-req';
import createAppointmentReq from './requests/create-appointment-req';
import appointmentDetailsReq from './requests/appointment-details-req';

export default combineReducers({
  appointmentList,
  locations,
  changeRoomModal,
  editPaymentAmountModal,
  changePaidStatusModal,
  changeStatus,
  pinAppointment,
  updateRoom,
  filter,
  appointmentLocations,
  record,
  validatePatientInfo,
  createAppointmentReq,
  changePaidStatus,
  appointmentDetailsReq,
});



// WEBPACK FOOTER //
// ./src/redux/dashboard/index.js